
import React from "react"

export default function Contact() {
    return (
        <>
            <div id='contactSection'>
                <div>
                    <div id='contactLineOne'>
                        Vous avez un projet ? Nous sommes vos experts de confiance.
                    </div>
                    <div id='contactLineTwo'>
                        <a href='/contactus'>
                            Jasons ensemble !
                        </a>
                    </div>
                </div>
            </div>
        </>
    )
}
